














import ErrorMessagesComponent from "@/shared/components/ErrorMessages.vue";
import FormComponent from './Form/Form.vue';
import ResultsListComponent from './ResultsList/ResultsList.vue';
import {defineComponent, onMounted, PropType} from "@vue/composition-api";
import {useGetters, useStore} from "vuex-composition-helpers";
import {Config} from "@/apps/PeopleSearchWidget/models/config-viewmodel";
import {watchDebounced} from "@vueuse/core";

export default defineComponent({
  name: "PeopleSearchWidget",
  components: {
    ErrorMessagesComponent,
    FormComponent,
    ResultsListComponent
  },
  props: {
    configRaw: {type: Object as PropType<Config>, required: true}
  },
  setup: (props) => {
    const store = useStore()
    const {searchQuery, error} = useGetters(["searchQuery", "error"])

    watchDebounced(searchQuery, () => {
          store.dispatch('onChange')
        }, {
          debounce: 250,
          maxWait: 500
        }
    )

    onMounted(async () => {
      await store.dispatch('init', props.configRaw);
    })

    return {
      error,
      searchQuery
    }
  }
})
